/**
 * UCM历史记录筛选组件
 * 提供航班号、机场、报文类型、日期等筛选条件
 */

import React from 'react';
import { Form, Input, Select, DatePicker, Button, Row, Col, Space } from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';
import { UCM_TYPE_OPTIONS } from '../constants/ucmConstants';
import AirportSelector from '../../../../components/common/AirportSelector';

const { RangePicker } = DatePicker;

const UcmHistoryFilter = ({ onFilter, onReset, loading }) => {
    const [form] = Form.useForm();

    // 处理筛选
    const handleFilter = () => {
        const values = form.getFieldsValue();
        
        // 处理日期范围 - 始终设置 start_date 和 end_date 字段
        let filters = { ...values };
        if (values.dateRange && values.dateRange[0] && values.dateRange[1]) {
            filters.start_date = values.dateRange[0].format('YYYY-MM-DD');
            filters.end_date = values.dateRange[1].format('YYYY-MM-DD');
        } else {
            // 如果日期范围被清空，明确设置为 null
            filters.start_date = null;
            filters.end_date = null;
        }
        delete filters.dateRange;
        
        // 将空值转换为null而不是删除，这样可以覆盖旧的筛选值
        Object.keys(filters).forEach(key => {
            if (filters[key] === undefined || filters[key] === '' || filters[key] === null) {
                filters[key] = null;
            }
        });
        
        onFilter(filters);
    };

    // 重置筛选
    const handleReset = () => {
        form.resetFields();
        onReset();
    };

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={handleFilter}
            style={{ marginBottom: 16 }}
        >
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item
                        label="航班号"
                        name="flight_number"
                        style={{ marginBottom: 0 }}
                    >
                        <Input
                            placeholder="输入航班号（模糊匹配）"
                            allowClear
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item
                        label="起飞机场"
                        name="departure_airport"
                        style={{ marginBottom: 0 }}
                    >
                        <AirportSelector
                            valueType="iata_code"
                            placeholder="选择起飞机场"
                            allowClear
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item
                        label="报文类型"
                        name="ucm_type"
                        style={{ marginBottom: 0 }}
                    >
                        <Select
                            placeholder="选择报文类型"
                            options={UCM_TYPE_OPTIONS}
                            allowClear
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item
                        label="航班日期范围"
                        name="dateRange"
                        style={{ marginBottom: 0 }}
                    >
                        <RangePicker
                            style={{ width: '100%' }}
                            format="YYYY-MM-DD"
                            placeholder={['开始日期', '结束日期']}
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item
                        label="创建人"
                        name="created_by_user_id"
                        style={{ marginBottom: 0 }}
                    >
                        <Input
                            placeholder="输入创建人ID"
                            allowClear
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item label=" " style={{ marginBottom: 0 }}>
                        <Space>
                            <Button
                                type="primary"
                                icon={<SearchOutlined />}
                                onClick={handleFilter}
                                loading={loading}
                            >
                                筛选
                            </Button>
                            <Button
                                icon={<ReloadOutlined />}
                                onClick={handleReset}
                            >
                                重置
                            </Button>
                        </Space>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};

export default UcmHistoryFilter;

